import { OverrideType } from '../inputs/OverrideInput/types';

export const overrideLogicDisplay = (value?: boolean | null): OverrideType =>
  value == null ? 'NULL' : value ? 'SHOW' : 'HIDE';
